import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api_url } from "../../helpers/apiHelpers";

const Dashboard = () => {
  // State to store visitor count
  const [visitors, setVisitors] = useState(0);

  useEffect(() => {
    // Generate random visitor count
    const currentVisitors = 1 + Math.floor(Math.random() * 10);
    setVisitors(currentVisitors); // Update state
  }, []);

  const [allUsersData, setAllUsersData] = useState([]);

  const getAllData = async () => {
    const response = await fetch(`${api_url}/api/admin/get-users-data`);

    const result = await response.json();
    if (result.status === 201) {
      setAllUsersData(result.result);
    } else {
      setAllUsersData([]);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  return (
    <div className="container py-3 dashboard-manu">
      <div className="row">
        <div className="col-lg-4 mt-3">
          <div className="card p-3 bg-info h-100">
            <h4 className="text-white fw-bold">Total Users</h4>
            <h2 className="display-6 fw-bold text-center text-white">{allUsersData && allUsersData.length}</h2>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="card p-3 bg-success h-100">
            <h4 className="text-white fw-bold">Income Tax</h4>
            <p>Total Office : 0</p>
            <p>Total Employee : 0</p>
            <p>Completed Work : 0</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="card p-3 bg-secondary h-100">
            <h4 className="text-white fw-bold">Pension</h4>
            <p>Total Office : 0</p>
            <p>Total Employee : 0</p>
            <p>Completed Work : 0</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="card p-3 bg-primary h-100">
            <h4 className="text-white fw-bold">GPF Final</h4>
            <p>Total Office : 0</p>
            <p>Total Employee : 0</p>
            <p>Completed Work : 0</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="card p-3 bg-info h-100">
            <h4 className="text-white fw-bold">GIS </h4>
            <p>Total Office : 0</p>
            <p>Total Employee : 0</p>
            <p>Completed Work : 0</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="card p-3 bg-danger h-100">
            <h4 className="text-white fw-bold">Inter District Transfer</h4>
            <p>Total Office : 0</p>
            <p>Total Employee : 0</p>
            <p>Completed Work : 0</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="card p-3 bg-warning h-100">
            <h4 className="text-dark fw-bold">GPF Non Refundable</h4>
            <p className="text-dark">Completed Work : 0</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
